type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  image?: string;
  compact?: boolean;
};

export function PageHero({ eyebrow, title, description, image, compact = false }: PageHeroProps) {
  return (
    <section
      className={`page-hero${compact ? " page-hero--compact" : ""}`}
      style={image ? { "--hero-image": `url(${image})` } as React.CSSProperties : undefined}
    >
      <div className="page-hero__shade" />
      <div className="container page-hero__content">
        <p className="eyebrow eyebrow--light">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </section>
  );
}
